import React from 'react'
import { StyleSheet, css } from 'aphrodite'

import logo from '../../../assets/LemonIsotipo.png'
import Grid from '@material-ui/core/Grid'


export default class LemonSection extends React.Component{
 render(){
  return(
		<Grid className={css(styles.MainContainer)} container justify="center" alignItems="center">
			<Grid item>
				<img className={css(styles.ImageLogo)} src={logo} alt=""/>
			</Grid>
		</Grid>
   );
 }
}

const styles = StyleSheet.create({
	MainContainer: {
		minHeight: 400
	},
	ImageLogo : {
		height: 100,
		filter: 'drop-shadow(0px 2px 6px rgba(0,21,64,.14)) drop-shadow(0 10px 20px rgba(0,21,64,.14))'
	}
})


// WEBPACK FOOTER //
// ./src/Components/Home/LemonSection/LemonSection.js